import { BasicModalContext } from './basic-modal-context';
import { SpecialWizard } from './special-wizard';

export class SpecialWizardModalContext extends BasicModalContext {
  constructor(public specialWizard: SpecialWizard) {
    super();
    this.class = 'lg';
    this.config = { specialWizard };
  }
}
